import { createAsyncThunk } from "@reduxjs/toolkit";
import { liveUsageMgmtProviderSelector } from "../../../selectors/store-selectors/liveUsageMgmtProviderSelector";
import { liveUsageMgmtAccountIdsSelector } from "../../../selectors/store-selectors/liveUsageMgmtAccountIdsSelector";
import { RootState } from "@/store/store";
import { getResourcesVisibilitiesByAccountIdsAndProviderThunk } from "@/store/live-usage-mgmt/thunks/resources/resource-visibility/getResourcesVisibilitiesByAccountIdsAndProviderThunk";

export const getLiveUsageMgmtAccountsVisibilitiesThunk = createAsyncThunk(
  "liveUsageMgmt/getLiveUsageMgmtAccountsVisibilities",
  async (_, { getState, dispatch }) => {
    const state = getState() as RootState;

    const provider = liveUsageMgmtProviderSelector(state);
    const accountIds = liveUsageMgmtAccountIdsSelector(state);

    if (!accountIds || !provider) {
      return;
    }

    await dispatch(
      getResourcesVisibilitiesByAccountIdsAndProviderThunk({
        accountIds,
        provider,
      }),
    );
  },
);
